/**
 * Standardized logic for calculating property development feasibility scores.
 * 
 * Score components:
 * 1. Terrain (40 pts max)
 * 2. Regulatory Ease (40 pts max) 
 * 3. Scale / Potential (20 pts max)
 */
export const calculateFeasibilityScore = (property) => {
    if (!property) return 0;
    
    let score = 0;
    
    // 1. Terrain (40 pts max)
    const slope = property.avg_slope_percent_LAH || 0;
    if (slope < 10) score += 40;
    else if (slope < 20) score += 25;
    else if (slope < 30) score += 10;
    
    // 2. Regulatory Ease (40 pts max)
    // No CDP is more favorable
    if (!property.requires_cdp) score += 40;
    else score += 10;
    
    // 3. Scale / Potential (20 pts max)
    const mda = property.mda_ft2 || 0;
    const mfa = property.mfa_ft2 || 0;
    
    // Sites with high buildable area get more points
    if (mda > 10000 || mfa > 10000) score += 20;
    else if (mda > 5000 || mfa > 5000) score += 15;
    else if (mda > 0 || mfa > 0) score += 5;
    
    return score;
};

/**
 * Returns a score color for UI indicators.
 */
export const getScoreColor = (score) => {
    if (score >= 80) return "emerald";
    if (score >= 50) return "amber";
    return "rose";
};
